import { render, staticRenderFns } from "./boardGalleryStyle.vue?vue&type=template&id=e7c6bfb2&scoped=true&"
import script from "./boardGalleryStyle.vue?vue&type=script&lang=js&"
export * from "./boardGalleryStyle.vue?vue&type=script&lang=js&"
import style0 from "./boardGalleryStyle.vue?vue&type=style&index=0&id=e7c6bfb2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7c6bfb2",
  null
  
)

export default component.exports